/** Shared helper so axios calls include the active store. */

export function getActiveStoreId() {
    return (
        localStorage.getItem('selectedStoreId') ||
        sessionStorage.getItem('selectedStoreId') ||
        null
    );
}

export function withStoreHeaders(extraHeaders = {}) {
    const storeId = getActiveStoreId();
    return {
        ...extraHeaders,
        ...(storeId ? { 'X-Store-Id': storeId } : {}),
    };
}
